import { render } from "./VBtn.vue?vue&type=template&id=30b511fe&scoped=true"
import script from "./VBtn.vue?vue&type=script&lang=js"
export * from "./VBtn.vue?vue&type=script&lang=js"

import "./VBtn.vue?vue&type=style&index=0&id=30b511fe&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b511fe"]])

export default __exports__